import { Channel as ReturnChannel } from "@redotech/congo-enums/channel";
import { useTranslation } from "@redotech/redo-i18n";
import type { ChannelState } from "@redotech/redo-return-core-common/return-flow/condition-validate";
import { ConditionTypeDetailsProps } from "@redotech/redo-return-ui/flows/return-flow/condition";
import { RedoListItem } from "@redotech/redo-web/arbiter-components/list/redo-list";
import { RedoSingleSelectDropdownInput } from "@redotech/redo-web/arbiter-components/select-dropdown/redo-single-select-dropdown-input";
import { memo, useMemo } from "react";

function getChannelOptions(t: (key: string) => string) {
  return [
    { value: ReturnChannel.Web, label: t("Web") },
    { value: ReturnChannel.Pointofsale, label: t("Point of Sale") },
  ];
}

export const ChannelDetails = memo(function ChannelDetails({
  state,
  setState,
  disabled,
}: ConditionTypeDetailsProps<ChannelState>) {
  const { t } = useTranslation();
  const channelOptions: RedoListItem<ReturnChannel>[] = useMemo(
    () =>
      getChannelOptions(t).map((option) => ({
        id: option.value,
        value: option.value,
        type: "text" as const,
        text: option.label,
      })),
    [t],
  );

  const selectedChannel = state
    ? channelOptions.find((option) => option.value === state)
    : undefined;

  return (
    <RedoSingleSelectDropdownInput
      disabled={disabled}
      flexGrow
      label={t("Return channel")}
      options={channelOptions}
      optionSelected={({ item }) => setState(item.value)}
      placeholder={t("Select return channel...")}
      selectedItem={selectedChannel}
      size="xs"
    />
  );
});
